import { useEffect, useMemo, useState } from 'react';

// import utils from '../../utils';

export const tableViews = {
  LIST: 'LIST',
  CARDS: 'CARDS'
};

const useTable = (items, columns, defaultOrder = null) => {
  const propsItems = useMemo(() => (items || []).map(item => ({ ...item, isChecked: false })), [items]);

  // const [itemsAreLoaded, setItemsAreLoaded] = useState(false);
  const [itemsToShow, setItemsToShow] = useState([]);
  // const [searchText, setSearchText] = useState('');
  const [allItemsSelected, setAllItemsSelected] = useState(false);
  const [limit, setLimit] = useState(25);
  const [orderValue, setOrderValue] = useState(defaultOrder?.key || null);
  const [currentOrderFunction, setCurrentOrderFunction] = useState(() => defaultOrder?.func || null);
  const [filterValues, setFilterValues] = useState([]);
  const [filterGroupedValues, setFilterGroupedValues] = useState({});

  // Aplicar ordenamiento cuando cambian los items o la función de orden
  useEffect(() => {
    if (currentOrderFunction && propsItems.length > 0) {
      const sortedItems = [...propsItems].sort(currentOrderFunction);
      setItemsToShow(sortedItems);
    } else {
      setItemsToShow(propsItems);
    }
  }, [propsItems, currentOrderFunction]);

  // WE COMMENT THIS SINCE LOGIC WAS SIMPLIFIED
  // useEffect(() => {
  //   if (!itemsAreLoaded && items.length > 0) {
  //     setItemsToShow(propsItems);
  //     setItemsAreLoaded(true);
  //   }
  // }, [items.length, itemsAreLoaded, propsItems]);

  // SEARCHING FUNCTIONALITY MUST BE IMPLEMENTED AT THE BACKEND LEVEL NOT THE FRONT LEVEL
  // FOR THAT REASON WE COMMENT THIS FUNCTIONALITY
  // useEffect(() => {
  //   if (itemsAreLoaded) {
  //     setItemsToShow(
  //       propsItems.filter(item =>
  //         utils.filterBySearch(
  //           searchText,
  //           columns.map(({ key }) => item[key])
  //         )
  //       )
  //     );
  //   }
  // }, [columns, itemsAreLoaded, propsItems, searchText]);

  const changeItemSelectedHandler = (idx, checked) => {
    setItemsToShow(prevItems => {
      const itemsAux = [...prevItems];
      itemsAux[idx].isChecked = checked;
      return itemsAux;
    });
  };

  const changeSelectedAllItems = checked => {
    setItemsToShow(items.map(item => ({ ...item, isChecked: checked })));
  };

  const allItemsSelectedHandler = checked => {
    setAllItemsSelected(checked);
    changeSelectedAllItems(checked);
  };

  const changeOrderValueHandler = (newOrderValue, orderFunction) => {
    setOrderValue(newOrderValue);
    setCurrentOrderFunction(() => orderFunction);
  };

  const changeFilterValues = (newFilterValues, filterFunctions) => {
    setFilterValues(newFilterValues);
    // WE COMMENT THIS SINCE WE WILL DO FILTERING ON THE BACKEND
    // setItemsToShow(
    //   items.filter(
    //     item => newFilterValues.length === 0 || newFilterValues.map(filterKey => filterFunctions[filterKey](item)).some(show => show)
    //   )
    // );
  };

  const changeFilterGroupedValues = (key, newFilterValue) => {
    setFilterGroupedValues(prev => ({ ...prev, [key]: newFilterValue }));
  };

  return {
    // setSearchText,
    allItemsSelected,
    allItemsSelectedHandler,
    changeItemSelectedHandler,
    items: itemsToShow,
    limit,
    setLimit,
    orderValue,
    changeOrderValueHandler,
    changeFilterValues,
    changeFilterGroupedValues,
    filterValues,
    filterGroupedValues,
    setFilterValues
  };
};

export default useTable;
